import { Typography } from "@mui/material";
import { FC } from "react";
import { PageNotFoundWrapper } from "./PageNotFound.style";
import { PiSmileySadLight } from "react-icons/pi";

type IPageNotFoundProps = {};

export const PageNotFound: FC<IPageNotFoundProps> = () => {
  return (
    <PageNotFoundWrapper className="page-not-found-container">
      <PiSmileySadLight className="emoji" />
      <Typography variant="h3">404</Typography>
      <Typography variant="h5">Page not found</Typography>
      <Typography variant="body1">
        The Page you are looking for does't exist or an other error occured.
        <a href="/quantlab-function-library" className="go-back">
          Go back
        </a>
        , or choose a new direction.
      </Typography>
    </PageNotFoundWrapper>
  );
};
